module.exports = __webpack_public_path__ + "static/media/silhouettes-trees-people-wood-4mp.caad5ca6.jpg";